var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"6","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"d":"M12 12L15.5 15.5","stroke":"currentColor","stroke-width":"2","stroke-linecap":"square"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }